import * as yup from 'yup';
import { PaymentTermDayType } from '@carvia/ros-client-types';

export const yieldManagementDunningSchema = yup.object({
  defaultPaymentTermDays: yup.number().integer().min(0).max(365).required(),
  defaultPaymentTermDayType: yup
    .mixed<PaymentTermDayType>()
    .oneOf(Object.values(PaymentTermDayType))
    .required(),
});
